import { Injectable } from '@angular/core';

import { Action, Selector, State, StateContext } from '@ngxs/store';

import { patch } from '@ngxs/store/operators';
import { SetPageRefreshFlag } from './goals-state.actions';
import { GoalsStateModel, GOALS_STATE_TOKEN } from './goals-state.models';

@Injectable()
@State<GoalsStateModel>({
  name: GOALS_STATE_TOKEN,
  defaults: {
    refreshOnManageCampaignsClose: false,
  },
})
export class GoalsState {
  @Selector()
  static needRefresh({ refreshOnManageCampaignsClose }: GoalsStateModel): boolean {
    return refreshOnManageCampaignsClose;
  }

  @Action(SetPageRefreshFlag)
  setPageRefreshFlag(
    { setState }: StateContext<GoalsStateModel>,
    { refreshOnManageCampaignsClose }: SetPageRefreshFlag,
  ) {
    setState(patch({ refreshOnManageCampaignsClose }));
  }
}
